import { StoreModel, StoreModelType } from '@aksia/infrastructure';
import { InvestmentVehicle } from '../investment-vehicle/investment-vehicle';
import { IInvestmentProgram } from '../../interfaces/investment-program/investment-program.interface';

export class InvestmentProgram
  extends StoreModel
  implements IInvestmentProgram
{
  investmentProgramId: number | undefined = undefined;
  name: string | undefined = undefined;
  managementCompanyId: number | undefined = undefined;
  assetClassId: number | undefined = undefined;
  sectorId: number | undefined = undefined;
  strategyId: number | undefined = undefined;
  substrategyId: number | undefined = undefined;
  primaryRegionId: number | undefined = undefined;
  isAumFirstMonth: boolean | undefined = undefined;
  isAumMaster: boolean | undefined = undefined;
  isAumQuarterly: boolean | undefined = undefined;

  @StoreModelType(() => InvestmentVehicle)
  funds: Array<InvestmentVehicle> | undefined = undefined;
}
